// The default column header colours: a light grey fill and dark text, as stored for a header nobody
// has customised. They're also, exactly, the light theme's surface-sunken and body tokens.
//
// Kept in a module of their own, importing nothing, because app-constants needs them for a new
// hub's defaults: taken from helpers/colour, they closed an import cycle back to app-constants
// (through helpers/api), and the defaults could be read before they were initialised.
export const DEFAULT_HEADER_BACKGROUND_COLOUR = '#f5f5f5'
export const DEFAULT_HEADER_TEXT_COLOUR = '#333333'
